import { render, staticRenderFns } from "./ModalDiagnosis.vue?vue&type=template&id=3aec3ea0&"
import script from "./ModalDiagnosis.vue?vue&type=script&lang=js&"
export * from "./ModalDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports